import { logoutType } from '@Constants/User';

export function logout () {
  return {
    type: logoutType,
  };
}
